export default __webpack_public_path__ + "static/assets/d00d5538ae5cae6519913798d5dddd34.png";